import { ReducerActionTestPayload, StateLogbook } from "../types";

export const test = (state: StateLogbook, action: ReducerActionTestPayload): StateLogbook => state